import { Module } from "vuex";
import { State } from "@/store/modules/print/state";
import Mutations from "@/store/modules/print/mutations";
import Getters from "@/store/modules/print/getters";
import Actions from "@/store/modules/print/actions";

export class Print implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
